export enum SexoEnum {
    M = 77,
    F = 70
  }